import get from "lodash/get";
import { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { AppContext } from "../../../data/AppContextContainer";
import { registerAuthInterceptors, setAuthSecret } from "../../../services/api";
import {
  getCustomConversationDetails,
  getEmailMessageDetails,
  isRunningInFront
} from "../../../services/front";

export const AppRouter = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const context = useContext(AppContext);

  useEffect(() => {
    if (isRunningInFront) {
      setAuthSecret(window.location.search);
      window.Front.on("conversation", handleConversation);
      window.Front.setPanelWidth(500);
    } else {
      registerAuthInterceptors(errorMessage => {
        const redirectPath = get(location, "pathname", "/");

        context.showNotification({
          title: "Authentication error",
          message: `${errorMessage} - please log in again.`,
          type: "negative"
        });

        navigate("/login", {
          state: { redirectPath }
        });
      });
    }
  }, []);

  const handleConversation = ({ conversation, message, otherMessages }) => {
    if (conversation && conversation.message_type === "custom") {
      const { mailBoxName, threadId, homeCode, conversationId, guestEmail } =
        getCustomConversationDetails(message, conversation);

      if (mailBoxName && threadId) {
        navigate(`/mailbox/${mailBoxName}/thread/${threadId}/${homeCode}`);
      } else if (conversationId && guestEmail) {
        navigate(`/search/bcom/conversation/${guestEmail}/${conversationId}`);
      } else {
        navigate("/not-found");
      }
    } else {
      return handleEmailMessage(message, otherMessages);
    }
  };

  const handleEmailMessage = (message, otherMessages) => {
    if (!message) {
      return navigate("/not-found");
    }

    const {
      airbnbMessage,
      mailBoxName,
      threadId,
      guestEmail,
      platformRef,
      vrboListingId,
      expediaListingId
    } = getEmailMessageDetails(message, otherMessages);

    if (airbnbMessage) {
      if (threadId) {
        return navigate(`/mailbox/${mailBoxName}/thread/${threadId}`);
      }

      return navigate(`/mailbox/${mailBoxName}`);
    }

    // We match Booking.com messages with guest email
    if (guestEmail) {
      if (platformRef) {
        return navigate(`/search/bcom/${guestEmail}/${platformRef}`);
      }

      return navigate(`/search/bcom/${guestEmail}`);
    }

    // We match VRBO messages with their reference or listing ID
    if (vrboListingId) {
      if (platformRef) {
        return navigate(`/search/vrbo/${vrboListingId}/${platformRef}`);
      }

      return navigate(`/search/vrbo/${vrboListingId}`);
    }

    // We can match Expedia messages with listing ID only
    if (expediaListingId) {
      return navigate(`/search/expedia/${expediaListingId}`);
    }
  };

  return children;
};

export default AppRouter;
